// src/i18n/translations.ts

export const translations = {
  en: {
    common: {
      back: "Back",
      continue: "Continue",
      submit: "Submit",
      loading: "Loading...",
      error: "Error",
      retry: "Retry",
      clear: "Clear",
      welcomeBack: "Welcome back",
      yes: "Yes",
      no: "No",
    },
    home: {
      mission: "Digital Agriculture Mission",
      title: "Empowering | India's | Annadatas",
      subtitle: "Niti-Setu uses AI to match you with eligible agricultural schemes based on your profile.",
      btnVoice: "Speak to Niti-Setu",
      descVoice: "Use your voice to check eligibility from official documents",
      btnForm: "Fill Eligibility Form",
      descForm: "Answer guided questions with PDF document evidence",
      ragTitle: "How RAG works",
      ragStep1: "Official PDFs",
      ragDesc1: "Scheme guidelines ingested",
      ragStep2: "Vector Search",
      ragDesc2: "Relevant rules retrieved",
      ragStep3: "AI Reasoning",
      ragDesc3: "Decision with proof cited",
      statsTitle: "Active Schemes Tracking",
      statsDesc: "Real-time updates from Central & State portals",
      welcomeFarmer: "Welcome, Farmer",
    },
    voice: {
      badge: "AI Voice Mode",
      title_start: "Your Personal AI",
      title_highlight: "Voice Advisor",
      subtitle: "Tap the mic and speak, or type your details below.",
      instruction: "Speak naturally (e.g., 'I am a 45-year-old farmer with 2 acres of land...')",
      listening: "Listening carefully...",
      stop: "Stop Recording",
      start: "Start Recording",
      retry: "Tap to retry",
      analyzing: "AI is analyzing your voice...",
      detected: "Detected {count} details",
      or_type: "or type your details",
      details: "Your details",
      clear: "Clear",
      chars: "characters",
      quick_add: "Quick add",
      guided_form: "Prefer a guided form instead",
      submit: "Submit Voice Profile",
      placeholder: "Type your farmer profile details here...",
      example: "Example: I am a small farmer from Maharashtra growing wheat...",
      errors: {
        no_support: { title: "Browser not supported", msg: "Voice input requires Chrome, Edge, or Safari. Please use the form." },
        denied: { title: "Microphone access denied", msg: "Allow microphone access in your browser settings to continue." },
        no_speech: { title: "No speech detected", msg: "We didn't hear anything. Speak clearly and make sure your mic is on." },
        network: { title: "Network error", msg: "Voice recognition needs internet. Check your connection." },
        other: { title: "Microphone error", msg: "Something went wrong. Try again or type below." }
      }
    },
    form: {
      title: "Farmer Eligibility Profile",
      subtitle: "Guided Form",
      progress: "Question {current} of {total}",
      step: "Step {current}",
      checking: "Checking via RAG...",
      next: "Next Step",
      finish: "Check Eligibility",
      fields: {
        name: { label: "Full Name", placeholder: "e.g. Ramesh Kumar" },
        age: { label: "Age", placeholder: "e.g. 42", unit: "years" },
        landSize: { label: "Land Size", placeholder: "e.g. 1.5", unit: "acres" },
        income: { label: "Annual Income", placeholder: "e.g. 120000", unit: "₹" },
        cropName: { label: "Main Crop", placeholder: "e.g. Wheat" },
        season: { label: "Current Season", placeholder: "Kharif / Rabi / Summer" },
        category: { label: "Farmer Category", placeholder: "Small / Marginal / Tenant / Sharecropper" },
        state: { label: "State", placeholder: "e.g. Maharashtra" },
        district: { label: "District", placeholder: "e.g. Pune" },
        landOwner: { label: "Do you own or lease agricultural land?" },
        govtJob: { label: "Are you a government employee (current or retired)?" },
        cropType: { label: "Do you grow notified crops (wheat, rice, sugarcane, etc.)?" },
        loanee: { label: "Do you have an institutional farm loan?" },
        creditHistory: { label: "Do you have a clean loan repayment history (no defaults)?" },
      }
    },
    results: {
      title: "Eligibility Results",
      eligibility_report: "Eligibility Report · RAG Verified",
      results_suffix: "'s Results",
      your_report: "Your Eligibility Report",
      qualify_prefix: "You qualify for ",
      of: "of",
      schemes: "schemes",
      matches: "Potential Matches",
      scanned: "Official Guidelines Scanned",
      eligible: "Eligible",
      potential: "Highly Potential",
      not_eligible: "Not Eligible",
      schemes_checked: "Schemes Checked",
      results_label: "Results",
      confidence: "Confidence Meter",
      analysis: "AI Analysis",
      reasoning: "AI Reasoning & Decisions",
      viewApply: "View & Apply",
      noResults: "No potential schemes found at this time.",
      found_count: "{count} Match Found",
      found_plural: "{count} Matches Found",
      backed_by_docs: "Decisions backed by official PDF documents",
      match_pct: "{pct}% Match",
      reasoning_label: "Reasoning",
      evidence_label: "Evidence Found",
    },
    detail: {
      backToResults: "Back to All Results",
      downloadApp: "Download Pre-filled Application",
      generating: "Generating Application...",
      applyAt: "Where to Apply",
      requiredDocs: "Required Documents",
      criteriaStatus: "Criteria Status",
      officialSite: "Visit Official Portal",
    }
  },
  hi: {
    common: {
      back: "पीछे",
      continue: "जारी रखें",
      submit: "जमा करें",
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      retry: "पुनः प्रयास करें",
      clear: "साफ करें",
      welcomeBack: "आपका स्वागत है",
      yes: "हाँ",
      no: "नहीं",
    },
    home: {
      mission: "डिजिटल कृषि मिशन",
      title: "भारत के | अन्नदाताओं | का सशक्तिकरण",
      subtitle: "नीति-सेतु आपके प्रोफाइल के आधार पर आपको सही कृषि योजनाओं से जोड़ने के लिए AI का उपयोग करता है।",
      btnVoice: "नीति-सेतु से बात करें",
      descVoice: "आधिकारिक दस्तावेजों से पात्रता जांचने के लिए अपनी आवाज का उपयोग करें",
      btnForm: "पात्रता फॉर्म भरें",
      descForm: "पीडीएफ दस्तावेज साक्ष्यों के साथ निर्देशित प्रश्नों के उत्तर दें",
      ragTitle: "RAG कैसे काम करता है",
      ragStep1: "आधिकारिक पीडीएफ",
      ragDesc1: "योजना दिशानिर्देशों का संकलन",
      ragStep2: "वेक्टर खोज",
      ragDesc2: "प्रासंगिक नियम खोजे गए",
      ragStep3: "AI तर्क",
      ragDesc3: "प्रमाण के साथ निर्णय",
      statsTitle: "सक्रिय योजनाओं की ट्रैकिंग",
      statsDesc: "केंद्र और राज्य पोर्टलों से रीयल-टाइम अपडेट",
      welcomeFarmer: "नमस्ते, किसान भाई",
    },
    voice: {
      badge: "AI वॉयस मोड",
      title_start: "आपका अपना AI",
      title_highlight: "वॉयस सलाहकार",
      subtitle: "माइक पर टैप करें और बोलें, या नीचे अपना विवरण टाइप करें।",
      instruction: "स्वाभाविक रूप से बोलें (जैसे, 'मैं 2 एकड़ जमीन वाला 45 वर्षीय किसान हूं...')",
      listening: "सुन रहे हैं...",
      stop: "रिकॉर्डिंग बंद करें",
      start: "रिकॉर्डिंग शुरू करें",
      retry: "पुनः प्रयास करने के लिए टैप करें",
      analyzing: "AI आपकी आवाज़ का विश्लेषण कर रहा है...",
      detected: "मिली {count} जानकारी",
      or_type: "या अपना विवरण टाइप करें",
      details: "आपका विवरण",
      clear: "साफ करें",
      chars: "अक्षर",
      quick_add: "त्वरित जोड़ें",
      guided_form: "इसके बजाय निर्देशित फॉर्म का उपयोग करें",
      submit: "वॉयस प्रोफाइल जमा करें",
      placeholder: "अपने किसान प्रोफाइल का विवरण यहाँ टाइप करें...",
      example: "उदाहरण: मैं महाराष्ट्र का एक छोटा किसान हूँ जो गेहूँ उगाता हूँ...",
      errors: {
        no_support: { title: "ब्राउज़र समर्थित नहीं है", msg: "वॉयस इनपुट के लिए क्रोम, एज या सफारी की आवश्यकता है। कृपया फॉर्म का उपयोग करें।" },
        denied: { title: "माइक्रोफोन एक्सेस अस्वीकृत", msg: "जारी रखने के लिए अपने ब्राउज़र सेटिंग्स में माइक्रोफोन एक्सेस की अनुमति दें।" },
        no_speech: { title: "कोई आवाज़ नहीं मिली", msg: "हमें कुछ सुनाई नहीं दिया। स्पष्ट रूप से बोलें और सुनिश्चित करें कि आपका माइक चालू है।" },
        network: { title: "नेटवर्क त्रुटि", msg: "वॉयस रिकग्निशन के लिए इंटरनेट की आवश्यकता है। अपना कनेक्शन जांचें।" },
        other: { title: "माइक्रोफोन त्रुटि", msg: "कुछ गलत हो गया। पुनः प्रयास करें या नीचे टाइप करें।" }
      }
    },
    form: {
      title: "किसान पात्रता प्रोफाइल",
      subtitle: "निर्देशित फॉर्म",
      progress: "प्रश्न {current} का {total}",
      step: "चरण {current}",
      checking: "RAG के माध्यम से जांच हो रही है...",
      next: "अगला चरण",
      finish: "पात्रता जांचें",
      fields: {
        name: { label: "पूरा नाम", placeholder: "जैसे: रमेश कुमार" },
        age: { label: "आयु", placeholder: "जैसे: 42", unit: "वर्ष" },
        landSize: { label: "भूमि का आकार", placeholder: "जैसे: 1.5", unit: "एकड़" },
        income: { label: "वार्षिक आय", placeholder: "जैसे: 120000", unit: "₹" },
        cropName: { label: "मुख्य फसल", placeholder: "जैसे: गेहूं" },
        season: { label: "वर्तमान सीजन", placeholder: "खरीफ / रबी / जायद" },
        category: { label: "किसान श्रेणी", placeholder: "छोटा / सीमांत / बटाईदार" },
        state: { label: "राज्य", placeholder: "जैसे: महाराष्ट्र" },
        district: { label: "जिला", placeholder: "जैसे: पुणे" },
        landOwner: { label: "क्या आप कृषि भूमि के मालिक हैं या पट्टे पर ली है?" },
        govtJob: { label: "क्या आप सरकारी कर्मचारी हैं (वर्तमान या सेवानिवृत्त)?" },
        cropType: { label: "क्या आप अधिसूचित फसलें (गेहूँ, चावल, गन्ना, आदि) उगाते हैं?" },
        loanee: { label: "क्या आपके पास संस्थागत कृषि ऋण है?" },
        creditHistory: { label: "क्या आपका ऋण चुकौती इतिहास साफ है (कोई चूक नहीं)?" },
      }
    },
    results: {
      title: "पात्रता परिणाम",
      eligibility_report: "पात्रता रिपोर्ट · RAG सत्यापित",
      results_suffix: " के परिणाम",
      your_report: "आपकी पात्रता रिपोर्ट",
      qualify_prefix: "आप इसके लिए पात्र हैं: ",
      of: "में से",
      schemes: "योजनाएं",
      matches: "संभावित मिलान",
      scanned: "आधिकारिक दिशानिर्देशों की जांच की गई",
      eligible: "पात्र",
      potential: "अत्यधिक संभावित",
      not_eligible: "पात्र नहीं",
      schemes_checked: "योजनाओं की जांच की गई",
      results_label: "परिणाम",
      confidence: "विश्वास मीटर",
      analysis: "AI विश्लेषण",
      reasoning: "AI तर्क और निर्णय",
      viewApply: "देखें और आवेदन करें",
      noResults: "इस समय कोई संभावित योजना नहीं मिली।",
      found_count: "{count} मिलान मिला",
      found_plural: "{count} मिलान मिले",
      backed_by_docs: "आधिकारिक पीडीएफ दस्तावेजों द्वारा समर्थित निर्णय",
      match_pct: "{pct}% मिलान",
      reasoning_label: "तर्क",
      evidence_label: "मिले साक्ष्य",
    },
    detail: {
      backToResults: "सभी परिणामों पर वापस जाएं",
      downloadApp: "भरा हुआ आवेदन डाउनलोड करें",
      generating: "आवेदन तैयार किया जा रहा है...",
      applyAt: "कहाँ आवेदन करें",
      requiredDocs: "आवश्यक दस्तावेज़",
      criteriaStatus: "मानदंड स्थिति",
      officialSite: "आधिकारिक पोर्टल पर जाएं",
    }
  }
};

export type Language = "en" | "hi";
export type TranslationDict = typeof translations.en;
